// types
import { Payment, Transaction } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// headers
import { getPaymentsHeaders } from './TableBasicPayments.headers';

// ui
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// props
export interface TableBasicPaymentsProps extends Omit<TableProps, 'headers'> {
	headersIncluded?: string[];
	data: Payment[];
	transaction?: Transaction;
}

export const TableBasicPayments = ({
	data = [],
	frame,
	headersIncluded = [
		'account',
		'amount',
		'date',
		'hash',
		'received',
		'reimbursed',
		'source',
		'status',
		'tax',
		'total',
	],
	transaction,
	...props
}: TableBasicPaymentsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableHeader[] = getPaymentsHeaders({ frame, headersIncluded, t, transaction });

	return <Table {...props} data={data} headers={headers} />;
};
